module.exports = __webpack_public_path__ + "static/media/FM_ASIC_TMD_September_2023.adb8eff3.pdf";